<prism-ui-page-content
    [illustrationUrl]="pageIllustrationUrl"
    [illustrationTop]="false">
    <div class="page-content" page-content>
        <prism-ui-heading
            slot="not-found-header"
            key-id="not-found-header"
            font-size="lg" 
            font-weight="regular" 
            is-uppercase="false"
            variant="default"
        >
        {{notFoundErrorContent?.title}}
        </prism-ui-heading>
        <prism-ui-copy>
            <p [innerHTML]="notFoundErrorContent?.body"></p>
        </prism-ui-copy>
    <a routerLink="/">Go to the start of the Medical History Statement</a>
    </div>
</prism-ui-page-content>